/* ============================================================
   Ammerländer Schinkendiele - Präsent Konfigurator
   ============================================================ */

(function () {
  'use strict';

  // ── State ──────────────────────────────────────────────────
  const state = {
    products: [],
    baskets: [],
    praesente: [],       // Pre-made gift baskets
    cart: {},            // { productId: quantity }
    selectedBasket: null,
    selectedColor: null,  // Color choice for Kartons (rot/grün/blau)
    greetingCard: {
      design: 'classic',
      recipient: '',
      message: '',
      sender: '',
    },
    currentStep: 1,
    showReadyMade: false,
    templates: [],
    affinity: {},
    nudgeDismissed: false,
    filters: {
      search: '',
      category: 'all',
      vegetarian: false,
      vegan: false,
    },
    readyMadeFilters: {
      search: '',
      content: 'all',
      alcohol: 'all',
      size: 'all',
    },
    visibleProducts: {
      bestsellers: 20,
      popular: 20,
      rest: 20,
      filtered: 20,
    },
  };

  const PAGE_SIZE = 20;
  const MIN_ITEMS = 3; // Mindestanzahl Artikel für kostenlose Verpackung

  // ── Discount tiers ─────────────────────────────────────────
  const DISCOUNT_TIERS = [
    { min: 150, percent: 10, label: '10% Rabatt ab 150 €' },
    { min: 100, percent: 7, label: '7% Rabatt ab 100 €' },
    { min: 75, percent: 5, label: '5% Rabatt ab 75 €' },
    { min: 50, percent: 3, label: '3% Rabatt ab 50 €' },
  ];

  // ── Category icons ─────────────────────────────────────────
  // Simple monoline SVG icons (currentColor)
  const _i = (d) => `<svg class="cat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${d}</svg>`;
  const CATEGORY_ICONS = {
    'Schinken': _i('<path d="M6 6c0-1 1-2 3-2h6c2 0 3 1 3 2v12c0 1-1 2-3 2H9c-2 0-3-1-3-2V6z"/><path d="M6 10h12"/><path d="M10 4v2M14 4v2"/>'),
    'Mettwurst': _i('<path d="M7 12c0-4 2-8 5-8s5 4 5 8-2 8-5 8-5-4-5-8z"/><path d="M9 6l-2-2M15 6l2-2M9 18l-2 2M15 18l2 2"/>'),
    'Salami': _i('<circle cx="12" cy="12" r="8"/><circle cx="10" cy="10" r="1" fill="currentColor"/><circle cx="14" cy="11" r="1" fill="currentColor"/><circle cx="11" cy="14" r="1" fill="currentColor"/><circle cx="14" cy="15" r="0.7" fill="currentColor"/>'),
    'Aufstrich': _i('<rect x="4" y="12" width="16" height="8" rx="2"/><path d="M7 12V9a5 5 0 0 1 10 0v3"/><path d="M15 7l3-3"/>'),
    'Feinkost in Dosen': _i('<rect x="5" y="7" width="14" height="13" rx="1"/><path d="M5 11h14"/><ellipse cx="12" cy="5" rx="6" ry="2"/><path d="M8 5V7M16 5V7"/>'),
    'Eingekochtes': _i('<path d="M8 2h8"/><rect x="6" y="4" width="12" height="16" rx="2"/><path d="M6 8h12"/>'),
    'Fisch': _i('<path d="M2 12s3-4 8-4 8 4 8 4-3 4-8 4-8-4-8-4z"/><circle cx="16" cy="12" r="1" fill="currentColor"/><path d="M20 9l2-2M20 15l2 2"/>'),
    'Käse': _i('<path d="M4 18h16l-4-14H4l0 14z"/><circle cx="8" cy="14" r="1.2" fill="currentColor"/><circle cx="13" cy="12" r="1" fill="currentColor"/><circle cx="10" cy="9" r="0.8" fill="currentColor"/>'),
    'Tee': _i('<path d="M6 8h8v8a4 4 0 0 1-4 4h0a4 4 0 0 1-4-4V8z"/><path d="M14 10h2a2 2 0 0 1 0 4h-2"/><path d="M8 2v3M10 2v3M12 2v3"/>'),
    'Kaffee': _i('<path d="M6 8h8v8a4 4 0 0 1-4 4h0a4 4 0 0 1-4-4V8z"/><path d="M14 10h2a2 2 0 0 1 0 4h-2"/><path d="M10 2c0 1.5-2 1.5-2 3"/>'),
    'Konfitüren & Honig': _i('<rect x="5" y="10" width="14" height="10" rx="2"/><path d="M5 14h14"/><path d="M9 10V8a3 3 0 0 1 6 0v2"/><circle cx="12" cy="17" r="1.5" fill="currentColor"/>'),
    'Gebäck & Süßes': _i('<circle cx="8" cy="16" r="4"/><circle cx="16" cy="16" r="4"/><circle cx="12" cy="10" r="4"/>'),
    'Brot': _i('<ellipse cx="12" cy="14" rx="9" ry="5"/><path d="M3 14c0-5 4-10 9-10s9 5 9 10"/><path d="M8 14v-3M12 14v-4M16 14v-3"/>'),
    'Nudeln': _i('<path d="M4 6c4 0 4 4 8 4s4-4 8-4"/><path d="M4 12c4 0 4 4 8 4s4-4 8-4"/><path d="M4 18c4 0 4 2 8 2s4-2 8-2"/>'),
    'Senf & Saucen': _i('<path d="M10 2h4v4l2 2v12a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V8l2-2V2z"/>'),
    'Eingelegtes': _i('<rect x="6" y="5" width="12" height="15" rx="2"/><path d="M6 9h12"/><path d="M9 3h6"/><circle cx="10" cy="14" r="1.5" fill="currentColor"/><circle cx="14" cy="13" r="1" fill="currentColor"/><circle cx="12" cy="17" r="1" fill="currentColor"/>'),
    'Wein & Spirituosen': _i('<path d="M8 2h8l-1 6a5 5 0 0 1-3 4 5 5 0 0 1-3-4L8 2z"/><path d="M12 12v6"/><path d="M8 22h8"/><path d="M10 18h4"/>'),
    'Gebratenes & Fleisch': _i('<path d="M5 15a7 7 0 0 1 14 0"/><path d="M5 15h14"/><path d="M8 15v4M12 15v5M16 15v4"/><path d="M3 19h18"/>'),
    'Sonstiges': _i('<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M3 11h18"/><path d="M8 7V5h8v2"/>'),
  };

  const BASKET_ICONS = {
    'karton-2er': '📦',
    'karton-3er': '📦',
    'korb-klein': '🧺',
    'korb-gross': '🧺',
    'kiepe-klein': '🏺',
    'kiepe-gross': '🏺',
  };

  const COLOR_LABELS = {
    'rot': { label: 'Rot', hex: '#8B1A1A' },
    'grün': { label: 'Grün', hex: '#2D5A3D' },
    'blau': { label: 'Blau', hex: '#2A4066' },
  };

  // ── DOM refs ───────────────────────────────────────────────
  const $ = (sel) => document.querySelector(sel);
  const $$ = (sel) => document.querySelectorAll(sel);

  // ── Init ───────────────────────────────────────────────────
  function init() {
    state.products = window.KONFIG_PRODUCTS || [];
    state.baskets = window.KONFIG_BASKETS || [];
    state.praesente = window.KONFIG_PRAESENTE || [];
    state.templates = window.KONFIG_TEMPLATES || [];
    state.affinity = window.KONFIG_AFFINITY || {};

    // Check if returning from successful order
    if (window.location.search.includes('contact_posted=true')) {
      setTimeout(() => { $('#orderModal').classList.add('active'); }, 300);
    }

    buildCategoryFilters();
    renderTemplates();
    renderProducts();
    bindEvents();
    updateCartUI();
  }

  // ── Category Filters ───────────────────────────────────────
  function buildCategoryFilters() {
    const container = $('#categoryFilters');
    const cats = {};
    state.products.forEach((p) => {
      cats[p.category] = (cats[p.category] || 0) + 1;
    });

    // Sort by count descending
    const sorted = Object.entries(cats).sort((a, b) => b[1] - a[1]);

    sorted.forEach(([cat, count]) => {
      const btn = document.createElement('button');
      btn.className = 'cat-btn';
      btn.dataset.cat = cat;
      btn.innerHTML = `${CATEGORY_ICONS[cat] || '📦'} ${cat} <span class="cat-count">${count}</span>`;
      container.appendChild(btn);
    });
  }

  // ── Render Products ────────────────────────────────────────
  function renderProducts(keepScroll) {
    const grid = $('#productGrid');
    const filtered = getFilteredProducts();

    if (filtered.length === 0) {
      grid.innerHTML = '';
      $('#noResults').style.display = 'block';
      return;
    }

    $('#noResults').style.display = 'none';

    const isUnfiltered = state.filters.category === 'all' && !state.filters.search && !state.filters.vegetarian && !state.filters.vegan;

    if (isUnfiltered) {
      const bestsellers = filtered.filter(p => (p.popularity || 0) >= 5);
      const popular = filtered.filter(p => (p.popularity || 0) >= 2 && (p.popularity || 0) < 5);
      const rest = filtered.filter(p => (p.popularity || 0) < 2);

      let html = '';

      if (bestsellers.length > 0) {
        const shown = bestsellers.slice(0, state.visibleProducts.bestsellers);
        html += `<div class="popularity-section-header"><h3>Bestseller</h3><span class="section-subtitle">Am häufigsten in unseren Präsentkörben</span></div>`;
        html += `<div class="product-grid-inner">${renderProductCards(shown)}</div>`;
        if (bestsellers.length > state.visibleProducts.bestsellers) {
          html += `<button class="btn btn-secondary btn-load-more" data-section="bestsellers" data-total="${bestsellers.length}">Weitere Bestseller anzeigen (${bestsellers.length - state.visibleProducts.bestsellers} mehr)</button>`;
        }
      }

      if (popular.length > 0) {
        if (bestsellers.length > 0) html += '<div class="product-section-divider"></div>';
        const shown = popular.slice(0, state.visibleProducts.popular);
        html += `<div class="popularity-section-header"><h3>Beliebt</h3><span class="section-subtitle">Häufig gewählt von unseren Kunden</span></div>`;
        html += `<div class="product-grid-inner">${renderProductCards(shown)}</div>`;
        if (popular.length > state.visibleProducts.popular) {
          html += `<button class="btn btn-secondary btn-load-more" data-section="popular" data-total="${popular.length}">Weitere beliebte Produkte anzeigen (${popular.length - state.visibleProducts.popular} mehr)</button>`;
        }
      }

      if (rest.length > 0) {
        if (bestsellers.length > 0 || popular.length > 0) html += '<div class="product-section-divider"></div>';
        const shown = rest.slice(0, state.visibleProducts.rest);
        html += `<div class="popularity-section-header"><h3>Weitere Produkte</h3><span class="section-subtitle">${rest.length} Spezialitäten entdecken</span></div>`;
        html += `<div class="product-grid-inner">${renderProductCards(shown)}</div>`;
        if (rest.length > state.visibleProducts.rest) {
          html += `<button class="btn btn-secondary btn-load-more" data-section="rest" data-total="${rest.length}">Mehr Produkte anzeigen (${rest.length - state.visibleProducts.rest} mehr)</button>`;
        }
      }

      grid.innerHTML = html;
    } else {
      const shown = filtered.slice(0, state.visibleProducts.filtered);
      let html = `<div class="product-grid-inner">${renderProductCards(shown)}</div>`;
      if (filtered.length > state.visibleProducts.filtered) {
        html += `<button class="btn btn-secondary btn-load-more" data-section="filtered" data-total="${filtered.length}">Mehr Produkte anzeigen (${filtered.length - state.visibleProducts.filtered} mehr)</button>`;
      }
      grid.innerHTML = html;
    }
  }

  function resetVisibleProducts() {
    state.visibleProducts = { bestsellers: PAGE_SIZE, popular: PAGE_SIZE, rest: PAGE_SIZE, filtered: PAGE_SIZE };
  }

  function renderProductCards(products) {
    return products
      .map((p) => {
        const qty = state.cart[p.id] || 0;
        const selected = qty > 0;
        const imgHtml = p.image
          ? `<img class="product-img" src="${p.image}" alt="${escapeHtml(p.name)}" loading="lazy">`
          : `<div class="product-img-placeholder">${CATEGORY_ICONS[p.category] || '📦'}</div>`;

        let badge = '';
        if ((p.popularity || 0) >= 5) {
          badge = '<span class="popularity-badge bestseller">Bestseller</span>';
        } else if ((p.popularity || 0) >= 2) {
          badge = '<span class="popularity-badge beliebt">Beliebt</span>';
        }

        return `
        <div class="product-card ${selected ? 'selected' : ''}" data-id="${p.id}">
          ${badge}
          ${imgHtml}
          <div class="product-info">
            <div class="product-category">${p.category}</div>
            <div class="product-name">${escapeHtml(p.name)}</div>
            <div class="product-bottom">
              <span class="product-price">${formatPrice(p.price)}</span>
            </div>
            ${selected ? `
            <div class="product-qty">
              <button class="qty-btn qty-minus" data-id="${p.id}">−</button>
              <span class="qty-value">${qty}</span>
              <button class="qty-btn qty-plus" data-id="${p.id}">+</button>
            </div>` : ''}
          </div>
        </div>`;
      })
      .join('');
  }

  function getFilteredProducts() {
    return state.products.filter((p) => {
      if (state.filters.category !== 'all' && p.category !== state.filters.category) return false;
      if (state.filters.vegetarian && !p.vegetarian) return false;
      if (state.filters.vegan && !p.vegan) return false;
      if (state.filters.search) {
        const s = state.filters.search.toLowerCase();
        if (!p.name.toLowerCase().includes(s) && !p.category.toLowerCase().includes(s)) return false;
      }
      return true;
    });
  }

  // ── Render Baskets ─────────────────────────────────────────
  function renderBaskets() {
    const grid = $('#basketGrid');
    const { totalVolume, totalItems } = getCartStats();

    // Volume tracking is internal only - not shown to customers
    $('#itemCount').textContent = totalItems;

    // Score baskets: fitting ones first (sorted by best fit), then too-small
    const scored = state.baskets.map((b) => {
      const fillPercent = Math.min(100, (totalVolume / b.capacity_ml) * 100);
      const itemsFit = totalItems <= b.max_items;
      const volumeFits = totalVolume <= b.capacity_ml;
      const tight = totalVolume > b.capacity_ml * 0.85 && volumeFits;

      let statusClass, statusText, sortOrder;
      if (!volumeFits || !itemsFit) {
        statusClass = 'too-small';
        statusText = !itemsFit ? 'Zu wenig Plätze' : 'Zu klein';
        sortOrder = 2;
      } else if (tight) {
        statusClass = 'tight';
        statusText = 'Knapp passend';
        sortOrder = 1;
      } else {
        statusClass = 'fits';
        statusText = 'Passt perfekt';
        sortOrder = 0;
      }

      const fitScore = volumeFits && itemsFit ? fillPercent : -1;
      return { basket: b, fillPercent, statusClass, statusText, sortOrder, fitScore };
    });

    scored.sort((a, b) => {
      if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
      return b.fitScore - a.fitScore;
    });

    // Auto-select best fitting basket if none selected
    if (!state.selectedBasket && totalItems > 0) {
      const bestFit = scored.find((s) => s.sortOrder === 0 || s.sortOrder === 1);
      if (bestFit) {
        state.selectedBasket = bestFit.basket.id;
        if (bestFit.basket.colors && bestFit.basket.colors.length > 0) {
          state.selectedColor = bestFit.basket.colors[0];
        }
        setTimeout(() => updateCartUI(), 0);
      }
    }

    grid.innerHTML = scored
      .map(({ basket: b, fillPercent, statusClass, statusText }) => {
        const selected = state.selectedBasket === b.id;
        const recommended = scored[0]?.basket.id === b.id && scored[0]?.sortOrder < 2;

        let colorHtml = '';
        if (b.colors && b.colors.length > 0) {
          const currentColor = selected && state.selectedColor ? state.selectedColor : b.colors[0];
          colorHtml = `
          <div class="basket-colors" data-basket-id="${b.id}">
            ${b.colors.map((c) => {
              const info = COLOR_LABELS[c] || { label: c, hex: '#999' };
              return `<button class="color-swatch ${currentColor === c ? 'active' : ''}"
                data-color="${c}" style="background:${info.hex}" title="${info.label}"></button>`;
            }).join('')}
          </div>`;
        }

        return `
        <div class="basket-card ${statusClass} ${selected ? 'selected' : ''}" data-id="${b.id}">
          ${recommended ? '<span class="basket-recommended">Empfohlen</span>' : ''}
          <span class="basket-status ${statusClass}">${statusText}</span>
          <div class="basket-icon">${b.image && b.image.startsWith('http') ? `<img src="${b.image}" alt="${b.name}" class="basket-img">` : (BASKET_ICONS[b.id] || '📦')}</div>
          <div class="basket-name">${b.name}</div>
          <div class="basket-desc">${b.description}</div>
          <div class="basket-specs">
            <span class="basket-spec">Max. <strong>${b.max_items} Artikel</strong></span>
            <span class="basket-spec">${b.dimensions}</span>
          </div>
          ${colorHtml}
          <div class="basket-volume-bar">
            <div class="basket-volume-fill ${statusClass}" style="width:${fillPercent}%"></div>
          </div>
          <div class="basket-price">Kostenlos</div>
        </div>`;
      })
      .join('');
  }

  // ── Render Summary ─────────────────────────────────────────
  function renderSummary() {
    const products = getCartProducts();
    const basket = state.baskets.find((b) => b.id === state.selectedBasket);
    const { totalPrice } = getCartStats();

    // Products
    $('#summaryProducts').innerHTML = products
      .map(({ product, qty }) => {
        const imgHtml = product.image
          ? `<img class="summary-item-img" src="${product.image}" alt="">`
          : `<div class="summary-item-img" style="display:flex;align-items:center;justify-content:center;font-size:1.5rem">${CATEGORY_ICONS[product.category] || '📦'}</div>`;

        return `
        <div class="summary-item">
          ${imgHtml}
          <div class="summary-item-info">
            <div class="summary-item-name">${escapeHtml(product.name)}</div>
            <div class="summary-item-meta">${product.category} · ${qty}x</div>
          </div>
          <div class="summary-item-price">${formatPrice(product.price * qty)}</div>
          <button class="summary-item-remove" data-id="${product.id}" title="Entfernen">×</button>
        </div>`;
      })
      .join('');

    // Basket
    if (basket) {
      const colorInfo = basket.colors && state.selectedColor
        ? ` · Farbe: ${COLOR_LABELS[state.selectedColor]?.label || state.selectedColor}`
        : '';
      $('#summaryBasket').innerHTML = `
        <h4>${BASKET_ICONS[basket.id] || ''} ${basket.name}</h4>
        <p style="font-size:0.85rem;color:var(--text-light)">${basket.description}${colorInfo}</p>
        <p style="margin-top:8px;font-weight:600;color:var(--accent)">Kostenlos</p>
      `;
    }

    // Greeting
    const gc = state.greetingCard;
    if (gc.message || gc.recipient || gc.sender) {
      $('#summaryGreeting').innerHTML = `
        <h4>Grußkarte</h4>
        ${gc.recipient ? `<p style="font-size:0.85rem"><strong>${escapeHtml(gc.recipient)}</strong></p>` : ''}
        ${gc.message ? `<p style="font-size:0.85rem;font-style:italic;margin:4px 0">"${escapeHtml(gc.message)}"</p>` : ''}
        ${gc.sender ? `<p style="font-size:0.85rem;text-align:right">${escapeHtml(gc.sender)}</p>` : ''}
      `;
      $('#summaryGreeting').style.display = 'block';
    } else {
      $('#summaryGreeting').style.display = 'none';
    }

    // Pricing
    const subtotal = totalPrice;
    const discount = getDiscount(totalPrice);

    $('#summaryProductTotal').textContent = formatPrice(totalPrice);
    if ($('#summaryBasketPrice')) $('#summaryBasketPrice').textContent = 'Kostenlos';

    if (discount.percent > 0) {
      const discountAmount = totalPrice * (discount.percent / 100);
      $('#discountRow').style.display = 'flex';
      $('#discountPercent').textContent = discount.percent;
      $('#discountAmount').textContent = `-${formatPrice(discountAmount)}`;
      $('#summaryTotal').textContent = formatPrice(subtotal - discountAmount);
      $('#discountInfo').textContent = `${discount.label} auf den Warenwert`;
    } else {
      $('#discountRow').style.display = 'none';
      $('#summaryTotal').textContent = formatPrice(subtotal);

      // Show next tier hint
      const nextTier = getNextDiscountTier(totalPrice);
      if (nextTier) {
        const diff = nextTier.min - totalPrice;
        $('#discountInfo').textContent = `Noch ${formatPrice(diff)} bis zum ${nextTier.label}!`;
      } else {
        $('#discountInfo').textContent = '';
      }
    }
  }

  // ── Cart helpers ───────────────────────────────────────────
  function addToCart(productId) {
    state.cart[productId] = (state.cart[productId] || 0) + 1;
    updateCartUI();
    renderProducts();
  }

  function removeFromCart(productId) {
    if (state.cart[productId]) {
      state.cart[productId]--;
      if (state.cart[productId] <= 0) delete state.cart[productId];
    }
    updateCartUI();
    renderProducts();
  }

  function removeAllFromCart(productId) {
    delete state.cart[productId];
    updateCartUI();
    renderProducts();
    if (state.currentStep === 4) renderSummary();
  }

  function getCartStats() {
    let totalVolume = 0;
    let totalPrice = 0;
    let totalItems = 0;
    for (const [id, qty] of Object.entries(state.cart)) {
      const p = state.products.find((pr) => pr.id === id);
      if (p) {
        totalVolume += p.volume_ml * qty;
        totalPrice += p.price * qty;
        totalItems += qty;
      }
    }
    return { totalVolume, totalPrice, totalItems };
  }

  function getCartProducts() {
    return Object.entries(state.cart)
      .map(([id, qty]) => ({
        product: state.products.find((p) => p.id === id),
        qty,
      }))
      .filter((x) => x.product);
  }

  function getDiscount(productTotal) {
    for (const tier of DISCOUNT_TIERS) {
      if (productTotal >= tier.min) return tier;
    }
    return { percent: 0, label: '' };
  }

  function getNextDiscountTier(productTotal) {
    const remaining = [...DISCOUNT_TIERS].reverse();
    for (const tier of remaining) {
      if (productTotal < tier.min) return tier;
    }
    return null;
  }

  // ── Update Cart UI ─────────────────────────────────────────
  function updateCartUI() {
    const { totalVolume, totalPrice, totalItems } = getCartStats();

    // Floating cart
    const fc = $('#floatingCart');
    if (totalItems > 0) {
      fc.classList.add('visible');
    } else {
      fc.classList.remove('visible');
    }

    $('#cartCount').textContent = totalItems;
    $('#cartTotal').textContent = formatPrice(totalPrice);

    // Volume bar
    const basket = state.baskets.find((b) => b.id === state.selectedBasket);
    if (basket) {
      const pct = Math.min(100, (totalVolume / basket.capacity_ml) * 100);
      const fill = $('#volumeFillMini');
      fill.style.width = pct + '%';
      fill.className = 'volume-fill-mini';
      if (pct > 100) fill.classList.add('danger');
      else if (pct > 85) fill.classList.add('warning');
      $('#volumeLabel').textContent = `${Math.round(pct)}% von ${basket.name}`;
    } else {
      $('#volumeFillMini').style.width = '0%';
      $('#volumeLabel').textContent = 'Kein Korb gewählt';
    }

    // Smart suggestions (templates / mix nudge / affinity)
    updateSmartUI();

    // Next button state
    updateNextButton();
  }

  function updateNextButton() {
    const btn = $('#btnNext');
    const { totalItems } = getCartStats();

    switch (state.currentStep) {
      case 1:
        btn.disabled = totalItems < MIN_ITEMS;
        if (totalItems === 0) {
          btn.innerHTML = `Produkte wählen <span class="arrow">→</span>`;
        } else if (totalItems < MIN_ITEMS) {
          btn.innerHTML = `Noch ${MIN_ITEMS - totalItems} Artikel wählen <span class="arrow">→</span>`;
        } else {
          btn.innerHTML = `Weiter: Korb wählen <span class="arrow">→</span>`;
        }
        break;
      case 2:
        btn.disabled = !state.selectedBasket;
        btn.innerHTML = state.selectedBasket
          ? `Weiter: Grußkarte <span class="arrow">→</span>`
          : `Korb wählen <span class="arrow">→</span>`;
        break;
      case 3:
        btn.disabled = false;
        btn.innerHTML = `Zur Übersicht <span class="arrow">→</span>`;
        break;
      case 4:
        btn.style.display = 'none';
        break;
    }
  }

  // ── Step Navigation ────────────────────────────────────────
  function goToStep(step) {
    if (step < 1 || step > 4) return;

    // Hide all step contents
    $$('.step-content').forEach((el) => (el.style.display = 'none'));
    $(`#step${step}`).style.display = 'block';

    // Update stepper
    $$('.step').forEach((el) => {
      const s = parseInt(el.dataset.step);
      el.classList.remove('active', 'completed');
      if (s === step) el.classList.add('active');
      else if (s < step) el.classList.add('completed');
    });

    state.currentStep = step;

    // Render step-specific content
    if (step === 2) renderBaskets();
    if (step === 4) renderSummary();

    // Back button
    $('#backBtnArea').style.display = step > 1 ? 'block' : 'none';

    // Next button visibility
    $('#btnNext').style.display = step < 4 ? '' : 'none';

    updateNextButton();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ── Event Binding ──────────────────────────────────────────
  function bindEvents() {
    // Load more buttons
    $('#productGrid').addEventListener('click', (e) => {
      const loadMore = e.target.closest('.btn-load-more');
      if (loadMore) {
        const section = loadMore.dataset.section;
        state.visibleProducts[section] += PAGE_SIZE;
        renderProducts(true);
        return;
      }

      const card = e.target.closest('.product-card');
      if (!card) return;
      const id = card.dataset.id;

      // If click is on qty buttons
      const minus = e.target.closest('.qty-minus');
      const plus = e.target.closest('.qty-plus');

      if (minus) {
        removeFromCart(id);
      } else if (plus) {
        addToCart(id);
      } else {
        // Toggle: add 1 or remove all
        if (state.cart[id]) {
          // Don't remove on card click when qty controls exist
          // Only add more
          addToCart(id);
        } else {
          addToCart(id);
        }
      }
    });

    // Search
    $('#searchInput').addEventListener('input', (e) => {
      state.filters.search = e.target.value;
      resetVisibleProducts();
      renderProducts();
    });

    // Category filters
    $('#categoryFilters').addEventListener('click', (e) => {
      const btn = e.target.closest('.cat-btn');
      if (!btn) return;
      $$('.cat-btn').forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      state.filters.category = btn.dataset.cat;
      resetVisibleProducts();
      renderProducts();
    });

    // Diet filters
    $('#filterVegetarian').addEventListener('change', (e) => {
      state.filters.vegetarian = e.target.checked;
      resetVisibleProducts();
      renderProducts();
    });
    $('#filterVegan').addEventListener('change', (e) => {
      state.filters.vegan = e.target.checked;
      resetVisibleProducts();
      renderProducts();
    });

    // Basket selection + color picker
    $('#basketGrid').addEventListener('click', (e) => {
      // Color swatch click
      const swatch = e.target.closest('.color-swatch');
      if (swatch) {
        const basketId = swatch.closest('.basket-colors').dataset.basketId;
        state.selectedBasket = basketId;
        state.selectedColor = swatch.dataset.color;
        renderBaskets();
        updateCartUI();
        return;
      }

      const card = e.target.closest('.basket-card');
      if (!card) return;
      const id = card.dataset.id;
      const basket = state.baskets.find((b) => b.id === id);

      state.selectedBasket = id;
      if (basket.colors && basket.colors.length > 0 && !state.selectedColor) {
        state.selectedColor = basket.colors[0];
      } else if (!basket.colors) {
        state.selectedColor = null;
      }
      renderBaskets();
      updateCartUI();
    });

    // Greeting card
    const designs = $$('.card-design');
    designs.forEach((d) => {
      d.addEventListener('click', () => {
        designs.forEach((dd) => dd.classList.remove('selected'));
        d.classList.add('selected');
        state.greetingCard.design = d.dataset.design;
        updateCardPreview();
      });
    });

    $('#cardRecipient').addEventListener('input', (e) => {
      state.greetingCard.recipient = e.target.value;
      updateCardPreview();
    });

    $('#cardMessage').addEventListener('input', (e) => {
      state.greetingCard.message = e.target.value;
      $('#charCount').textContent = `${e.target.value.length}/300`;
      updateCardPreview();
    });

    $('#cardSender').addEventListener('input', (e) => {
      state.greetingCard.sender = e.target.value;
      updateCardPreview();
    });

    // Navigation
    $('#btnNext').addEventListener('click', () => {
      if (state.currentStep < 4) goToStep(state.currentStep + 1);
    });

    $('#btnBack').addEventListener('click', () => {
      if (state.currentStep > 1) goToStep(state.currentStep - 1);
    });

    // Stepper clicks
    $$('.step').forEach((s) => {
      s.addEventListener('click', () => {
        const step = parseInt(s.dataset.step);
        // Only allow going back or to completed steps
        if (step <= state.currentStep) goToStep(step);
      });
    });

    // Summary remove buttons
    $('#summaryProducts').addEventListener('click', (e) => {
      const btn = e.target.closest('.summary-item-remove');
      if (btn) {
        removeAllFromCart(btn.dataset.id);
      }
    });

    // Order button — show order form
    $('#btnOrder').addEventListener('click', () => {
      showOrderForm();
    });

    // Cancel order form
    const cancelBtn = $('#btnCancelOrder');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => {
        $('#orderFormModal').classList.remove('active');
      });
    }

    // Order form submit (AJAX)
    const orderForm = document.querySelector('#orderFormModal form');
    if (orderForm) {
      orderForm.addEventListener('submit', async function(e) {
        e.preventDefault();
        const detailsField = $('#orderDetailsField');
        const bodyField = $('#konfig-body');
        const orderText = buildOrderText();
        if (detailsField) detailsField.value = orderText;

        const userNote = bodyField ? bodyField.value : '';
        if (bodyField) bodyField.value = 'PR\u00c4SENT-KONFIGURATOR BESTELLUNG\n\n' + orderText + (userNote ? '\n\nAnmerkung vom Kunden: ' + userNote : '');

        const submitBtn = $('#btnSubmitOrder');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Wird gesendet...'; }

        try {
          await fetch(this.action, {
            method: 'POST',
            body: new URLSearchParams(new FormData(this)),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          });
          $('#orderFormModal').classList.remove('active');
          $('#orderModal').classList.add('active');
        } catch (err) {
          this.submit();
        } finally {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Bestellung absenden'; }
        }
      });
    }

    // Starter templates
    const tRow = $('#templatesRow');
    if (tRow) tRow.addEventListener('click', (e) => {
      const card = e.target.closest('.template-card');
      if (card) applyTemplate(card.dataset.template);
    });

    // Smart helper: affinity quick-add + nudge dismiss
    const smartHelper = $('#smartHelper');
    if (smartHelper) smartHelper.addEventListener('click', (e) => {
      const add = e.target.closest('.affinity-add');
      if (add) { addToCart(add.dataset.id); return; }
      if (e.target.closest('.nudge-dismiss')) { state.nudgeDismissed = true; updateSmartUI(); }
    });

    // Ready-made baskets
    $('#btnShowReadyMade').addEventListener('click', () => toggleReadyMadeView(true));
    $('#btnBackToCustom').addEventListener('click', () => toggleReadyMadeView(false));

    // Ready-made search
    $('#readyMadeSearch').addEventListener('input', (e) => {
      state.readyMadeFilters.search = e.target.value;
      renderReadyMade();
    });

    // Ready-made filter toggles
    $('#readyMadeToggles').addEventListener('click', (e) => {
      const tag = e.target.closest('.filter-tag');
      if (!tag) return;

      // Content filters
      if (tag.dataset.filter !== undefined) {
        const group = tag.closest('.filter-group');
        group.querySelectorAll('.filter-tag').forEach((t) => t.classList.remove('active'));
        tag.classList.add('active');
        state.readyMadeFilters.content = tag.dataset.filter;
      }

      // Alcohol filters
      if (tag.dataset.alcohol !== undefined) {
        const group = tag.closest('.filter-group');
        group.querySelectorAll('.filter-tag').forEach((t) => t.classList.remove('active'));
        tag.classList.add('active');
        state.readyMadeFilters.alcohol = tag.dataset.alcohol;
      }

      // Size filters
      if (tag.dataset.size !== undefined) {
        const group = tag.closest('.filter-group');
        group.querySelectorAll('.filter-tag').forEach((t) => t.classList.remove('active'));
        tag.classList.add('active');
        state.readyMadeFilters.size = tag.dataset.size;
      }

      renderReadyMade();
    });
  }

  function updateCardPreview() {
    const gc = state.greetingCard;
    const inner = $('.preview-card-inner');
    inner.className = `preview-card-inner ${gc.design}`;
    $('#previewRecipient').textContent = gc.recipient || 'Empfänger';
    $('#previewMessage').textContent = gc.message || 'Ihre Nachricht erscheint hier...';
    $('#previewSender').textContent = gc.sender || 'Absender';
  }

  // ── Ready-Made Baskets ──────────────────────────────────────
  function toggleReadyMadeView(show) {
    state.showReadyMade = show;
    if (show) {
      $('#step1').style.display = 'none';
      $('#readyMadeView').style.display = 'block';
      $('#floatingCart').classList.remove('visible');
      renderReadyMade();
    } else {
      $('#readyMadeView').style.display = 'none';
      $('#step1').style.display = 'block';
      updateCartUI();
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function getFilteredPraesente() {
    return state.praesente.filter((p) => {
      const f = state.readyMadeFilters;

      // Search
      if (f.search && !p.name.toLowerCase().includes(f.search.toLowerCase()) &&
          !p.short_description.toLowerCase().includes(f.search.toLowerCase())) {
        return false;
      }

      // Content filter
      if (f.content === 'meat' && !p.has_meat) return false;
      if (f.content === 'no-meat' && p.has_meat) return false;
      if (f.content === 'fish' && !p.has_fish) return false;
      if (f.content === 'tea' && !p.has_tea) return false;
      if (f.content === 'cheese' && !p.has_cheese) return false;
      if (f.content === 'vegetarian' && !p.is_vegetarian) return false;

      // Alcohol filter
      if (f.alcohol === 'yes' && !p.has_alcohol) return false;
      if (f.alcohol === 'no' && p.has_alcohol) return false;

      // Size filter
      if (f.size !== 'all' && p.size !== f.size) return false;

      return true;
    });
  }

  function renderReadyMade() {
    const grid = $('#readyMadeGrid');
    const filtered = getFilteredPraesente();

    $('#readyMadeCount').textContent = `${filtered.length} Präsent${filtered.length !== 1 ? 'e' : ''} gefunden`;

    if (filtered.length === 0) {
      grid.innerHTML = '';
      $('#readyMadeNoResults').style.display = 'block';
      return;
    }
    $('#readyMadeNoResults').style.display = 'none';

    grid.innerHTML = filtered
      .map((p) => {
        const tags = [];
        if (p.has_meat) tags.push('<span class="rm-tag meat">Fleisch</span>');
        if (p.has_fish) tags.push('<span class="rm-tag fish">Fisch</span>');
        if (p.has_tea) tags.push('<span class="rm-tag tea">Tee</span>');
        if (p.has_alcohol) tags.push('<span class="rm-tag alcohol">Alkohol</span>');
        if (p.has_cheese) tags.push('<span class="rm-tag cheese">Käse</span>');
        if (p.is_vegetarian) tags.push('<span class="rm-tag vegetarian">Vegetarisch</span>');

        const sizeLabels = { klein: 'Klein', mittel: 'Mittel', 'groß': 'Groß', premium: 'Premium' };

        const imgHtml = p.image
          ? `<img class="rm-card-img" src="${p.image}" alt="${escapeHtml(p.name)}" loading="lazy">`
          : '';

        return `
        <div class="rm-card">
          ${imgHtml}
          <div class="rm-card-body">
            <div class="rm-card-tags">${tags.join('')}</div>
            <div class="rm-card-name">${escapeHtml(p.name)}</div>
            <div class="rm-card-desc">${decodeEntities(p.short_description)}</div>
            <div class="rm-card-footer">
              <span class="rm-card-price">${formatPrice(p.price)}</span>
              <span class="rm-card-size">${sizeLabels[p.size] || p.size}</span>
            </div>
            <a href="${p.shop_url}" target="_blank" class="rm-card-link">
              Im Shop ansehen <span class="arrow">→</span>
            </a>
          </div>
        </div>`;
      })
      .join('');
  }

  // \u2500\u2500 Order Form \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  function showOrderForm() {
    const miniSummary = $('#orderMiniSummary');
    if (miniSummary) {
      const products = getCartProducts();
      const basket = state.baskets.find((b) => b.id === state.selectedBasket);
      const { totalPrice } = getCartStats();
      const discount = getDiscount(totalPrice);
      const discountAmount = totalPrice * (discount.percent / 100);
      const total = totalPrice - discountAmount;

      let html = '<strong>Ihre Konfiguration:</strong><br>';
      products.forEach(({ product, qty }) => {
        html += `<div class="oms-row"><span>${qty}x ${escapeHtml(product.name)}</span><span>${formatPrice(product.price * qty)}</span></div>`;
      });
      if (basket) {
        const colorInfo = state.selectedColor ? ` (${COLOR_LABELS[state.selectedColor]?.label || state.selectedColor})` : '';
        html += `<div class="oms-row"><span>Verpackung: ${basket.name}${colorInfo}</span><span>Kostenlos</span></div>`;
      }
      if (discount.percent > 0) {
        html += `<div class="oms-row"><span>Rabatt (${discount.percent}%)</span><span>-${formatPrice(discountAmount)}</span></div>`;
      }
      html += `<div class="oms-row oms-total"><span>Gesamtpreis</span><span>${formatPrice(total)}</span></div>`;
      miniSummary.innerHTML = html;
    }
    $('#orderFormModal').classList.add('active');
  }

  function buildOrderText() {
    const products = getCartProducts();
    const basket = state.baskets.find((b) => b.id === state.selectedBasket);
    const { totalPrice, totalVolume, totalItems } = getCartStats();
    const discount = getDiscount(totalPrice);
    const discountAmount = totalPrice * (discount.percent / 100);
    const total = totalPrice - discountAmount;
    const gc = state.greetingCard;

    let text = '=== PRODUKTE ===\n';
    products.forEach(({ product, qty }) => {
      text += `${qty}x ${product.name} (${formatPrice(product.price)}/Stk) = ${formatPrice(product.price * qty)}\n`;
    });
    text += `\nArtikel gesamt: ${totalItems} | Volumen: ${totalVolume} ml\n`;

    if (basket) {
      const colorInfo = state.selectedColor ? ` (${COLOR_LABELS[state.selectedColor]?.label || state.selectedColor})` : '';
      text += `\n=== VERPACKUNG ===\n${basket.name}${colorInfo} (Kostenlos)\n`;
    }

    if (gc.message || gc.recipient || gc.sender) {
      text += '\n=== GRUSSKARTE ===\n';
      if (gc.recipient) text += `An: ${gc.recipient}\n`;
      if (gc.message) text += `Nachricht: ${gc.message}\n`;
      if (gc.sender) text += `Von: ${gc.sender}\n`;
      text += `Design: ${gc.design}\n`;
    }

    text += '\n=== PREIS\u00dcBERSICHT ===\n';
    text += `Warenwert: ${formatPrice(totalPrice)}\n`;
    text += `Verpackung: Kostenlos\n`;
    if (discount.percent > 0) {
      text += `Rabatt (${discount.percent}%): -${formatPrice(discountAmount)}\n`;
    }
    text += `GESAMTPREIS: ${formatPrice(total)}\n`;
    text += `zzgl. 6,95 \u20ac Versandkosten (DHL)\n`;

    return text;
  }

  // ── Smart Suggestions ──────────────────────────────────────
  function getCartCategoryCounts() {
    const counts = {};
    for (const [id, qty] of Object.entries(state.cart)) {
      const p = state.products.find((pr) => pr.id === id);
      if (p) counts[p.category] = (counts[p.category] || 0) + qty;
    }
    return counts;
  }

  function renderTemplates() {
    const row = $('#templatesRow');
    if (!row || !state.templates.length) return;
    const cards = state.templates.map((t) => `
      <button class="template-card" data-template="${t.id}">
        <span class="template-emoji">${t.emoji || '🎁'}</span>
        <span class="template-name">${escapeHtml(t.name)}</span>
        <span class="template-sub">${escapeHtml(t.subtitle || '')}</span>
        <span class="template-meta">${t.productIds.length} Artikel · ca. ${formatPrice(t.price || 0)}</span>
        <span class="template-cta">Als Start wählen <span class="arrow">→</span></span>
      </button>`).join('');
    row.innerHTML = `
      <div class="templates-head">
        <h3>Schnellstart: bewährte Mischungen</h3>
        <span class="section-subtitle">Von uns zusammengestellt – danach frei anpassbar</span>
      </div>
      <div class="templates-scroll">${cards}</div>`;
  }

  function applyTemplate(id) {
    const t = state.templates.find((x) => x.id === id);
    if (!t) return;
    let added = 0;
    t.productIds.forEach((pid) => {
      if (state.products.find((p) => p.id === pid)) {
        state.cart[pid] = (state.cart[pid] || 0) + 1;
        added++;
      }
    });
    if (!state.selectedBasket && t.suggestedBasket) {
      const b = state.baskets.find((x) => x.id === t.suggestedBasket);
      if (b) {
        state.selectedBasket = b.id;
        if (b.colors && b.colors.length) state.selectedColor = b.colors[0];
      }
    }
    updateCartUI();
    renderProducts();
    showToast(`„${t.name}“ geladen – ${added} Artikel hinzugefügt. Jetzt frei anpassen.`);
    const grid = $('#productGrid');
    if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function getAffinitySuggestions(limit) {
    limit = limit || 4;
    const counts = getCartCategoryCounts();
    const cartCats = Object.keys(counts);
    if (!cartCats.length) return [];
    const score = {};
    cartCats.forEach((cat) => {
      (state.affinity[cat] || []).forEach((comp, idx) => {
        score[comp] = (score[comp] || 0) + counts[cat] * (5 - Math.min(idx, 4));
      });
    });
    const ranked = Object.entries(score)
      .filter(([cat]) => !counts[cat]) // only suggest categories not yet in the basket → broadens the mix
      .sort((a, b) => b[1] - a[1])
      .map(([cat]) => cat);
    const picks = [];
    for (const cat of ranked) {
      const best = state.products
        .filter((p) => p.category === cat && !state.cart[p.id])
        .sort((a, b) => (b.popularity || 0) - (a.popularity || 0))[0];
      if (best) picks.push(best);
      if (picks.length >= limit) break;
    }
    return picks;
  }

  function getMixNudge() {
    if (state.nudgeDismissed) return null;
    const counts = getCartCategoryCounts();
    const cats = Object.entries(counts);
    if (!cats.length) return null;
    cats.sort((a, b) => b[1] - a[1]);
    const [topCat, topQty] = cats[0];
    if (topQty >= 3 && cats.length < 3) {
      const comp = (state.affinity[topCat] || []).find((c) => !counts[c]);
      return { topCat, topQty, comp };
    }
    return null;
  }

  function updateSmartUI() {
    const row = $('#templatesRow');
    const helper = $('#smartHelper');
    const { totalItems } = getCartStats();

    if (row) row.style.display = totalItems === 0 ? 'block' : 'none';
    if (!helper) return;
    if (totalItems === 0) { helper.style.display = 'none'; return; }

    const nudgeEl = $('#mixNudge');
    const n = getMixNudge();
    if (nudgeEl && n) {
      nudgeEl.innerHTML = `
        <span class="nudge-icon">💡</span>
        <span class="nudge-text">Schon <strong>${n.topQty}× ${escapeHtml(n.topCat)}</strong> im Korb. Ein Präsent wirkt hochwertiger mit einer schönen Mischung${n.comp ? ` – wie wäre es mit <strong>${escapeHtml(n.comp)}</strong> dazu?` : '.'}</span>
        <button class="nudge-dismiss" title="Ausblenden">×</button>`;
      nudgeEl.style.display = 'flex';
    } else if (nudgeEl) {
      nudgeEl.style.display = 'none';
    }

    const strip = $('#affinityStrip');
    const sugg = getAffinitySuggestions(4);
    if (strip && sugg.length) {
      const cards = sugg.map((p) => `
        <div class="affinity-card">
          ${p.image ? `<img class="affinity-img" src="${p.image}" alt="${escapeHtml(p.name)}" loading="lazy">` : `<div class="affinity-img affinity-ph">${CATEGORY_ICONS[p.category] || '📦'}</div>`}
          <div class="affinity-info">
            <span class="affinity-cat">${escapeHtml(p.category)}</span>
            <span class="affinity-name">${escapeHtml(p.name)}</span>
            <span class="affinity-price">${formatPrice(p.price)}</span>
          </div>
          <button class="affinity-add" data-id="${p.id}">+ Hinzufügen</button>
        </div>`).join('');
      strip.innerHTML = `
        <div class="affinity-head"><h3>Passt gut dazu</h3><span class="section-subtitle">Beliebte Ergänzungen für eine schöne Mischung</span></div>
        <div class="affinity-scroll">${cards}</div>`;
      strip.style.display = 'block';
    } else if (strip) {
      strip.style.display = 'none';
    }

    helper.style.display = (n || sugg.length) ? 'block' : 'none';
  }

  function showToast(msg) {
    let t = document.getElementById('konfigToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'konfigToast';
      t.className = 'konfig-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('show'), 3500);
  }

  // ── Helpers ────────────────────────────────────────────────
  function formatPrice(price) {
    return price.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function decodeEntities(str) {
    const div = document.createElement('div');
    div.innerHTML = str;
    return div.textContent;
  }

  // ── Start ──────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', init);
})();
